import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute,Router } from "@angular/router";
import { FlashService } from "../../../flash/flash.service";
import { PersonalDetailsService } from "../../../services/personal-details.service";

@Component({
  selector: "app-personal-detail",
  templateUrl: "./personal-detail.component.html",
  styleUrls: ["./personal-detail.component.css"],
})
export class PersonalDetailComponent implements OnInit {
  public form: FormGroup;
  public fields: any[] ;
  exp_ans = [];
  tem: any;
  inValid: boolean = false;
  currentUser;
  answers:any[] = [];
  showform;
  params:any;
  public elementName = [];

  constructor(
    private service: PersonalDetailsService,
    private flashService: FlashService,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));

    this.fields = JSON.parse(sessionStorage.getItem("pd_answer"));

      /* Taking values from the url */
       this.route.params.subscribe(
        params => {
          this.params = params.id
        }
      );

    this.form = new FormGroup({});

    this.fields.forEach((x) => {

      if (x.type == "checkbox") {
        this.form.addControl(x.name, new FormGroup({}));

        x.options.forEach((o) => {
          (this.form.get(x.name) as FormGroup).addControl(
            o.key,
            new FormControl(false)
          );
        });
      } else {
        this.form.addControl(
          x.name,
          new FormControl(
            x.value || "",
            x.required ? Validators.required : null
          )
        );
      }
    });

    this.generateForm();
    this.getpd_answer()
  }

  getFields() {
    return this.fields;
  }

  getpd_answer() {
    this.service.getAnswer(this.params).subscribe(
      (data) => {
        this.tem = data.body;
        this.answers = this.tem.questions;
        const arr = this.answers

        this.answers.forEach(element => {
          this.showform = element.status
          
        });
      },
      (err) => {
        console.log("Get Answer Error:", err);
      }
    );
  }

  onSubmit() {
    this.exp_ans = [];

    let keys_data = Object.keys(this.form.value);
    let value_data = Object.values(this.form.value);

    keys_data.forEach((element, index) => {
      var item = this.fields.find((item) => item.name === element);

      if ((typeof value_data[index] === "object") === true) {

        var obj = value_data[index];

        var keys = Object.keys(obj);

        var filtered = keys.filter(function (key) {
          return obj[key];
        });

        this.exp_ans.push({ name:item.name, id: item.id, ans: filtered });
      } else {
        this.exp_ans.push({ name:item.name, id: item.id, ans: value_data[index] });
      }

      if(value_data[index] === undefined){
        return this.inValid = true;
     }
    })

     this.inValid = false;
    
     let obj = Object.values(this.form.value);
 
    obj.forEach((formValue) => {
       if (formValue === "") {
         this.inValid = true;
       }
     });
 
     this.elementName = [];
 
     this.exp_ans.forEach(ele => {
       if(!ele.ans){
         this.elementName.push(ele.name);
       }
     });
 
     if(this.elementName.length){
       this.inValid = true;
     }
 
     if(this.inValid === false) {
       this.updatePersonalDetails()
      };
  }

  generateForm() {
    this.form = new FormGroup({
      fields: new FormControl(JSON.stringify(this.fields)),
    });

    this.form = new FormGroup({});

    this.fields.forEach((x) => {
      if (x.type == "checkbox") {
        this.form.addControl(x.name, new FormGroup({}));
        x.options.forEach((o) => {
          (this.form.get(x.name) as FormGroup).addControl(
            o.key,
            new FormControl(false)
          );
        });
      } else {
        this.form.addControl(
          x.name,
          new FormControl(
            x.value || "",
            x.required ? Validators.required : null
          )
        );
      }
    });

  }

  //verify api call
  updatePersonalDetails() {
    const payload = {
      emp_id: this.params.toString(),
      data: this.exp_ans,
    };
    this.service.updatePersonalDetails(payload).subscribe(
      (data) => {
        if (data.body["success"]) {
          this.flashService.show(data.body["message"], "alert-success");
          this.getpd_answer()
        } else {
          this.flashService.show(data.body["message"], "alert-success");
          this.getpd_answer()
        }
      },
      (err) => {
        console.log("Verify Personal Details Form Error:", err);
      }
    );
  }

  back(){
    this.router.navigate(['/offboarding'])
  }
  
}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/offboarding/forms-view/personal-detail/personal-detail.component.ts